// @flow

import { reduxForm } from 'redux-form'
import { compose } from 'redux'
import { connect } from 'react-redux'
import config from 'src/config'
import Login from './Login'
import { withUser } from 'src/decorators'
import queryString from 'query-string'

const Form = reduxForm({
  destroyOnUnmount: true,
  enableReinitialize: false,
  form: config.loginForm.id,
})(Login)

const mapStateToProps = (state, props) => {
  const query = queryString.parse(props.location.search)

  return {
    initialValues: {
      email: query.email || '',
    },
  }
}

export default compose(
  withUser,
  connect(mapStateToProps),
)(Form)
